<template>
    <v-dialog v-model="claimPointDialog" scrollable max-width="600" persistent>
        <v-card class="mx-auto">
            <v-toolbar color="deep-purple accent-4" dark>
                <v-btn icon @click="closeDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title class="text-white">Claim Poin</v-toolbar-title>
            </v-toolbar>
            <div class="m-4">
                <v-row>
                    <v-col cols="12" v-if="this.unknonwnContact == true">
                        <v-text-field v-model="username" label="Nama Konsumen" required></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field v-model="token" label="Token" required></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field v-model="orderId" label="Order ID" required></v-text-field>
                    </v-col>
                </v-row>
                <div style="font-weight: bold;" v-if="data.data">
                    <span>Akun: {{ data.personInfo.id }}</span>
                    <br />
                    <span>Poin Ditambahkan: {{ data.data.total_points_redeemed }} poin</span>
                    <br />
                    <span>Poin Saat ini: {{ data.data.total_point_balance }} poin</span>
                </div>
                <v-btn class="mt-4" @click="claimPoint()" :loading="isLoading" :disabled="isLoading">
                    Proses Poin
                </v-btn>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
    import axios from "axios";
    import { mapState } from 'vuex'

    import Toast from '../plugins/vuenotification'

    export default {
        props: ['claimPointDialog', 'contactName', 'contactId', 'number', 'unknonwnContact', 'sessionId'], 

        computed: {
            ...mapState({
                sessionInfo: state => state.session.sessionInfo
            }),
        },

        data: function() {
            return {
                token: String(),
                orderId: String(),
                username: String(),

                data: Object(),

                isLoading: false,
            }
        },

        methods: {
            claimPoint: async function() {
                try {
                    this.isLoading = true

                    const qs = new URLSearchParams()
                    qs.append("phoneNumber", this.number)

                    if(this.unknonwnContact == false) {
                        qs.append("userId", this.contactId)
                        qs.append("name", this.contactName)
                    } else {
                        
                        qs.append("name", this.username)
                    }

                    const params = qs.toString()
    
                    const body = {
                        salesorderid : this.orderId,
                        token: this.token
                    }
    
                    const { data } = await axios.post(process.env.VUE_APP_API_URL + '/cmrc/point/claim?' + params, body)

                    this.data = data
                    this.isLoading = false

                    if(this.unknonwnContact == true) {
                        await this.mergeContact(data.personInfo.id, this.contactId)
                    }
                } catch (error) {
                    this.isLoading = false
                    
                    console.log("error-claim-point", error)
                    Toast.showToast("error", error.response.data.message)
                }
            },
            mergeContact: async function(personId, commContactId) {
                try {
                    const body = {
                        "personId": personId,
                        "commContactId": commContactId
                    }

                    await axios.put(process.env.VUE_APP_API_URL + '/contact/merge/', body)

                    // const { data } = await axios.get(process.env.VUE_APP_API_URL + '/contact/id/' + personId)

                    var postData = {
                        id: personId,
                        primaryPhoneNumber: commContactId,
                        name: this.username,
                        contactStatus: 'ACTIVE',
                        communicatorChannels: [{
                            number: commContactId,
                            wa: true,
                            sms: true
                        }],
                        sessionId: this.sessionId
                    };

                    this.$emit('saveContactCallback', true, personId, postData)

                    this.$router.push({
                        name: 'myconversation',
                        params: { id: encodeURIComponent(personId) },
                        query: {
                            status: 'open', 
                            sortOrder: 'lastActive', 
                            sortDir: 'desc', 
                            labels: '', 
                            custroles: '', 
                            lastMessagesDirection: '', 
                            stars: 'false', 
                            channel: ''
                        } 
                    });
                } catch (error) {
                    console.log("mergeContact", error)
                }
            },
            closeDialog: function() {
                this.$emit('closeDialog')

                this.token = String()
                this.orderId = String()
                this.data = Object()
            },
        }
    }
</script>